import { createContext } from 'react';

export type ITabNavigationContext = {
    activeIndex: number;
    navigateToTab: (newIndex: number) => void;
} | null;

export const TabNavigationContext = createContext<ITabNavigationContext>(null);
